import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "rightWrap"
};
const _hoisted_2 = {
  class: "titlebox"
};
const _hoisted_3 = {
  class: "contentwrap"
};
const _hoisted_4 = {
  class: "coordinateInput"
};
const _hoisted_5 = {
  class: "relative"
};
const _hoisted_6 = {
  key: 0,
  class: "more-content"
};
const _hoisted_7 = {
  class: "mtb15"
};
const _hoisted_8 = {
  class: "ullist"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "innerbox"
};
const _hoisted_11 = {
  class: "imgbox"
};
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  class: "mb12"
};
const _hoisted_14 = {
  key: 0
};
const _hoisted_15 = {
  class: "bottombutton"
};
const _hoisted_16 = {
  class: "bdmapcontainer"
};
const _hoisted_17 = {
  class: "mapsearchbox"
};
const _hoisted_18 = {
  id: "bdmap",
  class: "bdmap",
  ref: "bdmap"
};
const _hoisted_19 = {
  key: 0
};
const _hoisted_20 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_Search = _resolveComponent("Search");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_uploadfile = _resolveComponent("uploadfile");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_cascader = _resolveComponent("el-cascader");
  const _component_CaretRight = _resolveComponent("CaretRight");
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_CaretBottom = _resolveComponent("CaretBottom");
  const _component_el_collapse_item = _resolveComponent("el-collapse-item");
  const _component_pointtext = _resolveComponent("pointtext");
  const _component_pointicon = _resolveComponent("pointicon");
  const _component_el_collapse = _resolveComponent("el-collapse");
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_el_form = _resolveComponent("el-form");
  const _component_CircleCloseFilled = _resolveComponent("CircleCloseFilled");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString($props.isadd ? '添加' : '编辑') + "点位", 1), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_form, {
    ref: "formdata",
    model: $props.form
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      label: $props.formlabel.place_name,
      prop: "place_name",
      rules: [{
        required: true,
        message: `请填写${$props.formlabel.place_name}`
      }]
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $props.form.place_name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $props.form.place_name = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label", "rules"]), _createVNode(_component_el_form_item, {
      label: $props.formlabel.map_level,
      prop: "map_level",
      rules: [{
        required: true,
        message: `请选择${$props.formlabel.map_level}`,
        trigger: 'blur'
      }]
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: $props.form.map_level,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $props.form.map_level = $event),
        placeholder: "请选择"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.leveloptions, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.title,
            label: item.title,
            value: item.title
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label", "rules"]), _createVNode(_component_el_form_item, {
      label: $props.formlabel.map_coordinates,
      prop: "map_coordinates",
      rules: [{
        required: true,
        message: `请选择${$props.formlabel.map_coordinates}`
      }]
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_input, {
        modelValue: $props.form.map_coordinates,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $props.form.map_coordinates = $event)
      }, null, 8, ["modelValue"]), _createVNode(_component_el_icon, {
        onClick: $options.searchCoordinates
      }, {
        default: _withCtx(() => [_createVNode(_component_Search)]),
        _: 1
      }, 8, ["onClick"])]), _cache[27] || (_cache[27] = _createElementVNode("div", {
        class: "description"
      }, "请在地图上点击，坐标自动回填到输入框", -1))]),
      _: 1
    }, 8, ["label", "rules"]), _createVNode(_component_el_form_item, {
      label: $props.formlabel[4],
      prop: "4",
      rules: [{
        required: true,
        message: `请上传${$props.formlabel[4]}`
      }]
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [(_openBlock(), _createBlock(_component_uploadfile, {
        key: $data.key1,
        uploadList: $data.form4,
        name: "4",
        field: $props.formfield[4],
        width: 90,
        height: 90,
        onFileList: _cache[3] || (_cache[3] = $event => $options.fileListHandle($event, '4'))
      }, null, 8, ["uploadList", "field"])), _createVNode(_component_el_button, {
        class: "materialbtn",
        onClick: _cache[4] || (_cache[4] = $event => $options.openSourceMaterial(3))
      }, {
        default: _withCtx(() => _cache[28] || (_cache[28] = [_createTextVNode("素材库")])),
        _: 1
      })])]),
      _: 1
    }, 8, ["label", "rules"]), _createVNode(_component_el_form_item, {
      label: $props.formlabel.map_type
    }, {
      default: _withCtx(() => [_createVNode(_component_el_cascader, {
        modelValue: $props.form.map_type,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $props.form.map_type = $event),
        placeholder: "请选择分类",
        options: $data.typeList,
        props: $data.typeprops,
        clearable: "",
        onChange: $options.cascaderHandle
      }, null, 8, ["modelValue", "options", "props", "onChange"])]),
      _: 1
    }, 8, ["label"]), _createElementVNode("div", {
      class: "pointmore",
      onClick: _cache[6] || (_cache[6] = $event => $data.moreShow = !$data.moreShow)
    }, [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_CaretRight)]),
      _: 1
    }), _cache[29] || (_cache[29] = _createTextVNode("高级选项"))]), $data.moreShow ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_checkbox, {
      modelValue: $data.isFollowglobal,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.isFollowglobal = $event),
      label: "是否跟随全局样式",
      onChange: $options.followGlobalChange
    }, null, 8, ["modelValue", "onChange"])]), _createVNode(_component_el_collapse, {
      modelValue: $data.activeNames,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.activeNames = $event),
      onChange: $options.handleChange
    }, {
      default: _withCtx(() => [_createVNode(_component_el_collapse_item, {
        name: "1"
      }, {
        title: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
          _: 1
        }), _cache[30] || (_cache[30] = _createElementVNode("span", null, "选择样式", -1))]),
        default: _withCtx(() => [_createElementVNode("ul", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.pointOptions, (item, index) => {
          return _openBlock(), _createElementBlock("li", {
            class: _normalizeClass([{
              'active': $data.pointStyleIndex === index
            }, {
              'none': $props.form.cTemplateScore === 1 && index !== 1
            }]),
            key: index,
            onClick: $event => $options.pointStyleChange(item, index)
          }, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_cache[31] || (_cache[31] = _createElementVNode("i", {
            class: "icon-right"
          }, null, -1)), _createElementVNode("img", {
            src: item.url,
            alt: ""
          }, null, 8, _hoisted_12)]), _createElementVNode("h5", null, _toDisplayString(item.name), 1)])], 10, _hoisted_9);
        }), 128))])]),
        _: 1
      }), _withDirectives(_createVNode(_component_el_collapse_item, {
        name: "2"
      }, {
        title: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
          _: 1
        }), _cache[32] || (_cache[32] = _createElementVNode("span", null, "点位名称", -1))]),
        default: _withCtx(() => [(_openBlock(), _createBlock(_component_pointtext, {
          value: $data.seniorstyle.text,
          globalvalue: false,
          onData: $options.TextChange,
          key: new Date().toString()
        }, null, 8, ["value", "onData"]))]),
        _: 1
      }, 512), [[_vShow, $data.pointItem.text]]), _withDirectives(_createVNode(_component_el_collapse_item, {
        name: "3"
      }, {
        title: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
          _: 1
        }), _cache[33] || (_cache[33] = _createElementVNode("span", null, "点位图片", -1))]),
        default: _withCtx(() => [(_openBlock(), _createBlock(_component_pointicon, {
          title: "pointpic",
          value: $data.seniorstyle.pic,
          globalvalue: false,
          onData: $options.picChange,
          key: new Date().toString()
        }, null, 8, ["value", "onData"]))]),
        _: 1
      }, 512), [[_vShow, $data.pointItem.pic]]), _withDirectives(_createVNode(_component_el_collapse_item, {
        name: "4"
      }, {
        title: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
          _: 1
        }), _cache[34] || (_cache[34] = _createElementVNode("span", null, "点位图标", -1))]),
        default: _withCtx(() => [(_openBlock(), _createBlock(_component_pointicon, {
          title: "pointicon",
          value: $data.seniorstyle.icon,
          globalvalue: false,
          onData: $options.iconChange,
          key: new Date().toString()
        }, null, 8, ["value", "onData"]))]),
        _: 1
      }, 512), [[_vShow, $data.pointItem.icon]])]),
      _: 1
    }, 8, ["modelValue", "onChange"])])) : _createCommentVNode("", true), _cache[37] || (_cache[37] = _createElementVNode("div", {
      class: "conline"
    }, null, -1)), _createVNode(_component_el_form_item, {
      label: $props.formlabel[42],
      prop: "42",
      rules: [{
        required: true,
        message: `请选择${$props.formlabel[42]}`
      }]
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        modelValue: $props.form[42],
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $props.form[42] = $event)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.formoption[42], (item, index) => {
          return _openBlock(), _createBlock(_component_el_radio, {
            value: item.title,
            key: index
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
            _: 2
          }, 1032, ["value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label", "rules"]), _withDirectives(_createVNode(_component_el_form_item, {
      label: $props.formlabel[44],
      prop: "44"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $props.form[44],
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $props.form[44] = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"]), [[_vShow, $props.form[42] === '链接']]), _withDirectives(_createElementVNode("div", _hoisted_13, [_createVNode(_component_el_form_item, {
      class: "topbottom",
      label: $props.formlabel.introduce,
      prop: "introduce",
      rules: $props.form[42] === '弹窗' ? [{
        required: true,
        message: `请填写${$props.formlabel.introduce}`
      }] : []
    }, {
      default: _withCtx(() => _cache[35] || (_cache[35] = [_createElementVNode("div", {
        class: "richtext richcontent",
        id: "editor1"
      }, null, -1)])),
      _: 1
    }, 8, ["label", "rules"]), _createVNode(_component_el_form_item, {
      label: $props.formlabel.banner
    }, {
      default: _withCtx(() => [(_openBlock(), _createBlock(_component_uploadfile, {
        key: $data.key1,
        styletype: 2,
        uploadList: $props.form.banner,
        name: "4",
        field: $props.formfield.banner,
        onFileList: _cache[11] || (_cache[11] = $event => $options.fileListHandle($event, 'banner'))
      }, null, 8, ["uploadList", "field"]))]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: $props.formlabel.audio
    }, {
      default: _withCtx(() => [(_openBlock(), _createBlock(_component_uploadfile, {
        key: $data.key1,
        styletype: 3,
        uploadList: $props.form.audio,
        name: $props.formlabel.audio,
        field: $props.formfield.audio,
        onFileList: _cache[12] || (_cache[12] = $event => $options.fileListHandle($event, 'audio'))
      }, null, 8, ["uploadList", "name", "field"]))]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: $props.formlabel.video
    }, {
      default: _withCtx(() => [(_openBlock(), _createBlock(_component_uploadfile, {
        key: $data.key1,
        styletype: 3,
        uploadList: $props.form.video,
        name: $props.formlabel.video,
        field: $props.formfield.video,
        onFileList: _cache[13] || (_cache[13] = $event => $options.fileListHandle($event, 'video'))
      }, null, 8, ["uploadList", "name", "field"]))]),
      _: 1
    }, 8, ["label"]), $props.formlabel.audiodesc ? (_openBlock(), _createBlock(_component_el_form_item, {
      key: 0,
      label: $props.formlabel.audiodesc
    }, {
      default: _withCtx(() => [(_openBlock(), _createBlock(_component_uploadfile, {
        key: $data.key1,
        styletype: 3,
        uploadList: $props.form.audiodesc,
        name: $props.formlabel.audiodesc,
        field: $props.formfield.audiodesc,
        onFileList: _cache[14] || (_cache[14] = $event => $options.fileListHandle($event, 'audiodesc'))
      }, null, 8, ["uploadList", "name", "field"]))]),
      _: 1
    }, 8, ["label"])) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
      label: $props.formlabel.route
    }, {
      default: _withCtx(() => [$props.isadd ? (_openBlock(), _createElementBlock("div", _hoisted_14, [$data.bdmap.address === undefined ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        onClick: $options.bdDialogHandle
      }, {
        default: _withCtx(() => _cache[36] || (_cache[36] = [_createTextVNode("选择位置")])),
        _: 1
      }, 8, ["onClick"])) : (_openBlock(), _createElementBlock("p", {
        key: 1,
        class: "desc",
        onClick: _cache[15] || (_cache[15] = (...args) => $options.bdDialogHandle && $options.bdDialogHandle(...args))
      }, _toDisplayString($data.bdmap.address), 1))])) : _createCommentVNode("", true), !$props.isadd ? (_openBlock(), _createElementBlock("a", {
        key: 1,
        class: "desc",
        onClick: _cache[16] || (_cache[16] = (...args) => $options.bdDialogHandle && $options.bdDialogHandle(...args))
      }, _toDisplayString($data.bdmap.address ? $data.bdmap.address : '选择位置'), 1)) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: $props.formlabel.portal_link,
      prop: "portal_link"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $props.form.portal_link,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => $props.form.portal_link = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: $props.formlabel.special_link,
      prop: "special_link"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $props.form.special_link,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => $props.form.special_link = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: $props.formlabel.virtual_link,
      prop: "virtual_link"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $props.form.virtual_link,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => $props.form.virtual_link = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"])], 512), [[_vShow, $props.form[42] === '弹窗']]), _withDirectives(_createVNode(_component_el_form_item, {
      label: $props.formlabel.telphone,
      prop: "telphone"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $props.form.telphone,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => $props.form.telphone = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"]), [[_vShow, $props.form[42] === '弹窗']]), $props.form[42] === '弹窗' && $props.formlabel.opentime ? (_openBlock(), _createBlock(_component_el_form_item, {
      key: 1,
      label: $props.formlabel.opentime,
      prop: "opentime"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $props.form.opentime,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => $props.form.opentime = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"])) : _createCommentVNode("", true), _withDirectives(_createVNode(_component_el_form_item, {
      label: $props.formlabel.linkTarget,
      prop: "linkTarget"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        modelValue: $props.form.linkTarget,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => $props.form.linkTarget = $event),
        class: "ml-4"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.formoption.linkTarget, (item, index) => {
          return _openBlock(), _createBlock(_component_el_radio, {
            value: item.title,
            key: index
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
            _: 2
          }, 1032, ["value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"]), [[_vShow, $props.form[42] === '弹窗']]), _createVNode(_component_el_form_item, {
      label: $props.formlabel[34],
      prop: "34"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        modelValue: $props.form[34],
        "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => $props.form[34] = $event),
        class: "ml-4"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.formoption[34], (item, index) => {
          return _openBlock(), _createBlock(_component_el_radio, {
            value: item.title,
            key: index
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
            _: 2
          }, 1032, ["value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"])]),
    _: 1
  }, 8, ["model"])]), _createElementVNode("div", _hoisted_15, [_createVNode(_component_el_button, {
    plain: "",
    onClick: $options.pointclose
  }, {
    default: _withCtx(() => _cache[38] || (_cache[38] = [_createTextVNode("取消")])),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    type: "primary",
    plain: "",
    onClick: $options.submitHandle
  }, {
    default: _withCtx(() => _cache[39] || (_cache[39] = [_createTextVNode("确认")])),
    _: 1
  }, 8, ["onClick"])]), _createVNode(_component_el_dialog, {
    modelValue: $data.bdDialog,
    "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => $data.bdDialog = $event),
    title: $data.routeFlag ? '选择位置' : '搜索位置'
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_20, [_createVNode(_component_el_button, {
      onClick: _cache[24] || (_cache[24] = $event => $data.bdDialog = false)
    }, {
      default: _withCtx(() => _cache[42] || (_cache[42] = [_createTextVNode("取消")])),
      _: 1
    }), _createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[25] || (_cache[25] = $event => $data.bdDialog = false)
    }, {
      default: _withCtx(() => _cache[43] || (_cache[43] = [_createTextVNode("确定")])),
      _: 1
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createVNode(_component_el_icon, {
      class: "search"
    }, {
      default: _withCtx(() => [_createVNode(_component_Search)]),
      _: 1
    }), _cache[40] || (_cache[40] = _createElementVNode("input", {
      class: "inputel",
      id: "suggestId",
      placeholder: "输入地址搜索或指直接在下面选择定位"
    }, null, -1)), _cache[41] || (_cache[41] = _createElementVNode("div", {
      id: "searchResultPanel",
      style: {
        "border": "1px solid #C0C0C0",
        "width": "150px",
        "height": "auto",
        "display": "none"
      }
    }, null, -1)), _createVNode(_component_el_icon, {
      class: "iconclose"
    }, {
      default: _withCtx(() => [_createVNode(_component_CircleCloseFilled)]),
      _: 1
    })]), _createElementVNode("div", _hoisted_18, null, 512), $data.routeFlag ? (_openBlock(), _createElementBlock("h4", _hoisted_19, _toDisplayString($data.bdmap.address), 1)) : _createCommentVNode("", true)])]),
    _: 1
  }, 8, ["modelValue", "title"])], 512)), [[_vShow, $data.pointShow]]);
}